var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{ opened: _vm.opened }},[_c('strong',[_vm._v(_vm._s(_vm.question)+" "),_c('Plus',{staticClass:"icon"})],1),_c('p',[_vm._v(_vm._s(_vm.answer))])])
}
var staticRenderFns = []

export { render, staticRenderFns }